<template>
  <div>
    <!-- {{ deviceType }} -->
    <!-- <div v-if="deviceType == 'Mobile'">
      <el-row>
        <el-col :span="24" class="min-w-screen min-h-screen flex items-center justify-center">
          <div v-if="get_absen_loading || loading" class="loading-container">
            <div class="loader"></div>
          </div>
          <div v-if="!get_absen_loading || !loading">
            <div class="">
              <p class="text-base text-center roboto-light p-0 m-0">{{ get_absen.tanggal | konversi_tanggal }}</p> 
            </div>
            <div class="my-7">
              <p class="text-xl text-center roboto-light p-0 m-0">{{ get_absen.absenMasukSitkp | konversi_waktu }} - {{ get_absen.absenPulangSitkp | konversi_waktu }}</p> 
            </div>
            <div v-if="get_absen.absenMasuk == null && get_absen.absenMasukSitkp == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null">
              <el-button class="quicksand-300 uppercase w-full" type="danger" icon="el-icon-place" :loading="loading" @click="submit_absen_masuk">Absen Masuk</el-button>
            </div>
            <div class="mb-1" v-if="get_absen.absenSiang == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null && get_absen != 0">
              <el-button class="quicksand-300 uppercase w-full" type="warning" icon="el-icon-place" :loading="loading" @click="submit_absen_siang">Absen Siang</el-button>
            </div>
            <div v-if="get_absen.absenPulang == null && get_absen.absenPulangSitkp == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null">
              <el-button class="quicksand-300 uppercase w-full" type="success" icon="el-icon-place" :loading="loading" @click="submit_absen_pulang">Absen Pulang</el-button>
            </div>
            <div class="mt-5">
              <el-button class="quicksand-300 uppercase w-full" icon="el-icon-arrow-left" @click="getViews('/dashboard')">Kembali</el-button>
            </div>
            <div class="mt-1">
              <el-button class="quicksand-300 uppercase w-full" icon="el-icon-refresh" @click="refresh_web_page"></el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <div v-if="deviceType != 'Mobile'">
      <div v-if="get_absen_loading" class="loading-container">
        <div class="loader"></div>
      </div>
      <div v-if="!get_absen_loading">
        <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-3 pb-3 m-0">
          <div class="flex-grow">
            <p class="playfair-display-400 text-base p-0 m-0">Absen Pegawai</p>  
          </div>
          <!-- <div>
            <el-button class="quicksand-300 uppercase" type="danger" size="mini" icon="el-icon-place" v-if="get_absen.absenMasuk == null && get_absen.absenMasukSitkp == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null" :loading="loading" @click="submit_absen_masuk">Absen Masuk</el-button>
            <el-button class="quicksand-300 uppercase" type="warning" size="mini" icon="el-icon-place" v-if="get_absen.absenSiang == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null && get_absen != 0" :loading="loading" @click="submit_absen_siang">Absen Siang</el-button>
            <el-button class="quicksand-300 uppercase" type="success" size="mini" icon="el-icon-place" v-if="get_absen.absenPulang == null && get_absen.absenPulangSitkp == null && koordinat_terkini.latitude != null && koordinat_terkini.longitude != null && get_absen.kondisi != null && get_absen.kegiatan != null && get_absen.output != null && get_absen.progres != null" :loading="loading" @click="submit_absen_pulang">Absen Pulang</el-button>
          </div> -->
          <div class="ml-0.5" v-if="get_absen != 0">
            <el-button class="quicksand-300 uppercase" size="mini" icon="el-icon-edit" @click="open_dialogvisible(get_absen.kondisi, get_absen.kegiatan, get_absen.output, get_absen.progres)">Update Kegiatan, Output, dan Progress</el-button>
          </div>
        </div>
        <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0" v-if="get_absen != 0">
          <div class="flex-grow">
            <p class="text-gray-600 text-xs text-left roboto-light p-0 m-0">{{ get_absen.tanggal | konversi_tanggal }}</p>
            <p class="titillium-web-regular p-0 m-0">{{ get_absen.nama }}</p>
          </div>
          <div class="w-44">
            <p class="text-gray-600 text-sm text-left roboto-light p-0 m-0">{{ get_absen.absenMasukSitkp | konversi_waktu }} - {{ get_absen.absenPulangSitkp | konversi_waktu }}</p> 
          </div>
          <div class="w-44 ml-4">
            <p class="text-gray-600 text-sm text-right roboto-light p-0 m-0">Progress {{ get_absen.progres == null ? 0 : get_absen.progres }}%</p> 
          </div>
        </div>
        <div class="px-5 pt-2.5 pb-2.5 m-0" v-if="get_absen != 0">
          <el-row>
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Kegiatan</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ get_absen.kegiatan == null ? 'Belum ada kegiatan' : get_absen.kegiatan }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Output</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ get_absen.output == null ? 'Belum ada output' : get_absen.output | format_output }}</p>
            </el-col>
          </el-row>
          <el-row class="mt-2">
            <el-col :span="3">
              <p class="text-gray-600 text-sm roboto-light p-0 m-0">Evidence</p>
            </el-col>
            <el-col :span="21">
              <p class="text-gray-400 text-sm text-justify roboto-light p-0 m-0">{{ get_absen.output == null ? 'Belum ada evidence' : get_absen.output | format_evidence }}</p>
            </el-col>
          </el-row> 
        </div>
        <div v-if="get_absen != 0">
          <l-map v-if="showMap" :zoom="zoom" :center="get_absen.koordinat_masuk" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" style="height:400px;width:100%;">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="get_absen.koordinat_masuk" v-if="get_absen.latitude != null && get_absen.longitude != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Masuk</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="get_absen.koordinat_siang" v-if="get_absen.latitudeSiang != null && get_absen.longitudeSiang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Siang</div>
              </l-popup>
            </l-marker>
            <l-marker :lat-lng="get_absen.koordinat_pulang" v-if="get_absen.latitudePulang != null && get_absen.longitudePulang != null">
              <l-popup class="p-0 m-0">
                <div class="font-1">Absen Pulang</div>
              </l-popup>
            </l-marker>
          </l-map>
        </div>
      </div>
      <!-- {{ get_absen }} -->
      <el-dialog title="Update Kegiatan, Output, dan Progress" :visible.sync="dialogvisible" width="60%">
        <div>
          <div>
            <p class="p-0 m-0 font-2">Kondisi saat ini</p>
            <el-radio-group class="font-1" v-model="form.kondisi">
              <el-radio label="Sehat">Sehat</el-radio>
              <el-radio label="Kurang Sehat">Kurang Sehat</el-radio>
              <el-radio label="Sakit">Sakit</el-radio>
            </el-radio-group>
          </div>
          <div class="mt-3">
            <p class="p-0 m-0 font-2">Kegiatan</p>
            <el-input type="textarea" :rows="4" placeholder="Please input" class="" v-model="form.kegiatan"></el-input>
          </div>
          <div class="mt-3">
            <p class="p-0 m-0 font-2">Output</p>
            <el-input type="textarea" :rows="4" placeholder="Please input" class="" v-model="form.output"></el-input>
          </div>
          <div class="mt-3">
            <p class="p-0 m-0 font-2">Progress (%)</p>
            <el-input-number class="" v-model="form.progress" size="small" controls-position="right" :min="0" :max="100"></el-input-number>
          </div>
          <div class="mt-3">
            <p class="p-0 m-0 font-2">Evidence</p>
            <el-input placeholder="Please input" class="" v-model="form.evidence"></el-input>
            <p class="p-0 m-0 text-xs text-yellow-500 font-1">*evidence berupa link google drive atau link lainnya</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close_dialogvisible">Cancel</el-button>
          <el-button type="primary" size="mini" :loading="get_absen_loading" @click="submit_dialogvisible">Submit</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  props: {
    'deviceType': String
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    return {
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: { zoomSnap: 0.5 },
      showMap: true,
      koordinat_terkini: { latitude: null, longitude: null },
      loading: false,
      dialogvisible: false,
      form: { kondisi: "Sehat", kegiatan: null, output: null, output_1: [], output_2: null, progress: 0, absen_masuk: { lat: null, lon: null, lokasi: null }, absen_siang: { lat: null, lon: null, lokasi: null }, absen_pulang: { lat: null, lon: null, lokasi: null }, evidence: null },
    }
  },
  filters: {
    konversi_tanggal: function(value){
      moment.locale('id'); 
      return moment(value).format('dddd')+', '+moment(value).format('LL');
    },
    konversi_waktu: function(value){
      moment.locale('id'); 
      return value === null ? 'Belum Absen' : moment(value).format('HH.mm');
    },
    format_output: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[0];
      }
      return "Belum ada";
    },
    format_evidence: function(value) {
      if (value != null) {
        let abc = value.split("@");
        return abc[1];
      }
      return "Belum ada";
    },
  },
  computed: {
    get_absen() {
      let data_absen =  this.$store.state.absen.absen;
      return Object.keys(data_absen).length > 0 ? data_absen : 0
    },
    get_absen_loading() {
      return this.$store.state.absen.loading
    }
  },
  created() {
    this.$store.dispatch('absen/get_hari_ini')
    this.get_lokasi_terkini();
  },
  methods: {
    getViews: function(value) {
      if (this.$route.path !== value) {
        this.$router.push(value);
      }
    },
    get_lokasi_terkini: function() {
      this.loading = true;
      this.$watchLocation().then((coordinates) => {
        this.loading = false;
        this.koordinat_terkini.latitude = coordinates.lat;
        this.koordinat_terkini.longitude = coordinates.lng;
        // console.log(this.koordinat_terkini);
      });
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    open_dialogvisible: function(kondisi, kegiatan, output, progress) {
      this.dialogvisible = true;

      let abc = output.split("@");

      this.form.kondisi = kondisi;
      this.form.kegiatan = kegiatan;
      this.form.output = abc[0];
      this.form.progress = progress;
      this.form.evidence = abc[1];
    },
    close_dialogvisible: function() {
      this.dialogvisible = false;  
    },
    submit_dialogvisible: function() {
      this.loading = true;

      let kondisi = this.form.kondisi;
      let kegiatan = this.form.kegiatan;
      let progress = this.form.progress;

      this.form.output_2 = "" + this.form.output + "@" + this.form.evidence;

      let output = this.form.output_2;

      this.$store.dispatch("absen/update_kegiatan_output_progress", {kondisi, kegiatan, output, progress})
        .then(() => {
          this.loading = false;
          this.form.kondisi = "Sehat";
          this.form.kegiatan = null;
          this.form.output = null;
          this.form.output_1 = [];
          this.form.output_2 = null;
          this.form.progress = 0;
          this.form.evidence = null;
          this.$store.dispatch("absen/get_hari_ini");
          this.dialogvisible = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    submit_absen_masuk: function() {
      this.loading = true;

      let longitude = this.koordinat_terkini.longitude;
      let latitude = this.koordinat_terkini.latitude;

      this.$store.dispatch("absen/post_absen_masuk", { longitude, latitude })
      .then(() => {
        this.loading = false;
        this.$store.dispatch("absen/get_hari_ini");
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    submit_absen_siang: function() {
      this.loading = true;

      let longitude = this.koordinat_terkini.longitude;
      let latitude = this.koordinat_terkini.latitude;

      this.$store.dispatch("absen/post_absen_siang", { longitude, latitude })
      .then(() => {
        this.loading = false;
        this.$store.dispatch("absen/get_hari_ini");
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    submit_absen_pulang: function() {
      this.loading = true;

      let longitude = this.koordinat_terkini.longitude;
      let latitude = this.koordinat_terkini.latitude;

      this.$store.dispatch("absen/post_absen_pulang", { longitude, latitude })
      .then(() => {
        this.loading = false;
        this.$store.dispatch("absen/get_hari_ini");
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    refresh_web_page: function() {
      location.reload()
    }
  }
}
</script>